import React, { useEffect } from 'react'
import Icon from 'components/elements/Icon'

import { useActionless, useAppSelector } from 'redux/hooks'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import SimpleSpinner from 'components/elements/SimpleSpinner'

import { SET_COLLECTION_V2_STATE } from 'redux/collectionV2/actions/types'

import styles from './columnControls.module.scss'
import { CollectionV2State } from 'redux/collectionV2/types'

type Props = {}

const ColumnControls = ({}: Props) => {
  const autoColumns = useAppSelector(state => state.collectionV2.autoColumns)
  const columnData = useAppSelector(state => state.collectionV2.columnData)

  const [setCollectionV2State] = useActionless(SET_COLLECTION_V2_STATE)

  const [changingState, setChangingState] = React.useState(false)

  const handleStateChange = (newState: Partial<CollectionV2State>) => {
    setChangingState(true)

    setTimeout(() => setCollectionV2State(newState), 20)
  }

  useEffect(() => {
    if (changingState) setChangingState(false)
  }, [autoColumns, columnData])

  useEffect(() => {
    if (!autoColumns) document.body.classList.add('deck-overscroll-view')
    else document.body.classList.remove('deck-overscroll-view')

    return () => {
      document.body.classList.remove('deck-overscroll-view')
    }
  }, [autoColumns])

  return (
    <ArchidektDropdown
      menuClassName={styles.tableOptionsMenu}
      options={[
        {
          type: 'checkbox',
          label: 'Automatic columns',
          onChange: () => handleStateChange({ autoColumns: !autoColumns }),
          checked: autoColumns,
        },
        { type: 'spacer' },
        {
          icon: 'check circle',
          label: 'Select all',
          disabled: autoColumns,
          onClick: () => handleStateChange({ columnData: columnData.map(c => ({ ...c, enabled: true })) }),
        },
        {
          icon: 'cancel',
          label: 'Deselect all',
          disabled: autoColumns,
          onClick: () => handleStateChange({ columnData: columnData.map(c => ({ ...c, enabled: false })) }),
        },
        { type: 'spacer' },

        ...(columnData.map(column => ({
          type: 'checkbox',
          label: column.label,
          disabled: autoColumns,
          checked: column.enabled,
          onChange: () =>
            handleStateChange({
              columnData: columnData.map(c => (c.key === column.key ? { ...c, enabled: !c.enabled } : c)),
            }),
        })) as any),
      ]}>
      <button className={styles.tableOptionsTrigger}>
        <Icon name="cog" />
        Hide / add columns
        {changingState && <SimpleSpinner size="xSmall" />}
      </button>
    </ArchidektDropdown>
  )
}

export default ColumnControls
